import { Location } from 'history';
import {
    Box,
    Breadcrumbs,
    Button,
    CircularProgress,
    Divider,
    FormControl,
    FormControlLabel,
    LinearProgress,
    Menu,
    MenuItem,
    Modal,
    Radio,
    RadioGroup,
    Select,
    Skeleton,
    Tab,
    Typography
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import React, { useEffect, useState } from 'react';
import { CommonLayout, TransactionPagesDropdown } from '../../commonComponents';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getProfileData, get_account_type, registerMandate } from '../../../redux-store/actions/userManagement';
import { GetAccountType, RegisterMandateResponse } from '../../../redux-store/types/api-types';
import { RootStateType } from '../../../redux-store/reducers';

interface MandateValuesType {
    mandateAmount: string;
    bankAccount: string;
    bankName: string;
    ifscCode: string;
    ac_type: string
}
interface errorTypes {
    amount: string;
    bank: string
}
export default function Mandates({
    location
}: {
    location: Location<{ investorId: string; investorName: string }>
}): JSX.Element {
    const { investorId, investorName } = location?.state || { investorId: '', investorName: '' };
    const rm_id = useSelector((store: RootStateType) => store.auth.userDetails.Header_ID);
    const dispatch = useDispatch();
    const history = useHistory();
    // const [loading, setLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [submitModalPopup, setSubmitModalPopup] = useState<boolean>(false);
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [registerMandateRes, setRegisterMandateRes] = useState<RegisterMandateResponse | null>();
    const [radioValue, setRadioValue] = useState<string>("Emandate");
    const [mandateValues, setMandateValues] = useState<MandateValuesType>({
        mandateAmount: '',
        bankAccount: '',
        bankName: '',
        ifscCode: '',
        ac_type: ''
    })
    const [profileData, setProfileData] = useState<any>()
    const [accountID, setAccountID] = useState<string>()
    const [error, setError] = useState<errorTypes>({
        amount: '', bank: ''
    })

    const responsiveStyles = {
        '@media (max-width: 600px)': {
            width: '80%',
            fontSize: '14px',
        },
        '@media (max-width: 400px)': {
            width: '100%',
            fontSize: '12px',
        },
    };

    const breadcrumbs = [
        <Typography key="1" sx={{ color: '#BBB5B5 !important' }}>
            Total Investors
        </Typography>,
        <Typography key="2" sx={{ color: '#BBB5B5 !important' }}>
            {investorName}
        </Typography>,
        <Typography key="3" color="text.primary">
            Mandates
        </Typography>,
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const accountId = (await dispatch(
                    get_account_type({
                        rmID: rm_id,
                        ClientCode: investorId
                    })
                )) as unknown as GetAccountType;
                setAccountID(accountId.account_type[0].AccountId)
                const response = (await dispatch(
                    getProfileData({
                        AccountID: accountId.account_type[0].AccountId
                    })
                )) as unknown as any;
                setProfileData(response.profile_data);
                setLoading(false);
            } catch (e) {
                console.log((e as Error).message);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleSubmit = async () => {
        const errors: any = {}
        if (mandateValues.mandateAmount === "" || null || undefined) {
            errors.amount = "Please enter amount."

        }
        if (mandateValues.bankAccount === "" || null || undefined) {
            errors.bank = "Please select your bank account."

        }
        if (Object.keys(errors).length > 0) {
            setError(errors);
            return;
        }
        setSubmitLoading(true);

        try {
            const register_mandate = await dispatch(registerMandate({
                AccountID: accountID,
                AC_TYPE: mandateValues.ac_type,
                AccountNO: mandateValues.bankAccount,
                Amount: mandateValues.mandateAmount,
                BankName: mandateValues.bankName,
                IFSC_CODE: mandateValues.ifscCode,
                is_encrypted: true,
                mandate_type: radioValue === 'XSIP' ? 'X' : "N"
            })) as unknown as RegisterMandateResponse;

            setRegisterMandateRes(register_mandate);
            setSubmitModalPopup(true);
            console.log("register mandate response", register_mandate);
        } catch (e) {
            console.log((e as Error).message);
        } finally {
            setSubmitLoading(false);
        }
    };
    console.log("LOACTION", location);
    return (
        <div>

            <CommonLayout>
                <>
                    <TransactionPagesDropdown location={location} selectedValue='Mandates' />
                    <Box
                        sx={{
                            background: '#EEF9F4',
                            borderRadius: '16px',
                            px: 3,
                            py: 1.5,
                            mb: 2.5,
                        }}>
                        <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" />}
                            aria-label="breadcrumb"
                            sx={{
                                '& .MuiTypography-root': {
                                    fontSize: 20,
                                    lineHeight: '23px',
                                    fontWeight: 500,
                                    color: '#BBB5B5',
                                    '&.MuiTypography-body1': { color: '#22242C' },
                                    userSelect: 'none'
                                },
                                '& .MuiBreadcrumbs-separator': {
                                    '& .MuiSvgIcon-root': { color: 'rgba(0,0,0,0.6)' },
                                    '&:last-of-type': {
                                        background: 'red',
                                        '& .MuiSvgIcon-root': { color: '#22242C' },
                                        userSelect: 'none'
                                    },
                                },
                            }}>
                            {breadcrumbs}
                        </Breadcrumbs>
                    </Box>



                    <Box sx={{
                        bgcolor: 'common.white',
                        boxShadow: '0px 4px 28px 2px rgba(0, 0, 0, 0.08)',
                        borderRadius: '5px',
                        p: 3,
                    }}>
                        {loading ? (
                            <LinearProgress />
                        ) : (
                            <>
                                <RadioGroup
                                    sx={{ flexDirection: 'row', flexWrap: 'nowrap', userSelect: 'none' }}
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={radioValue}
                                    onChange={(e: any) => {
                                        setRadioValue(e.target.value)
                                    }
                                    }

                                >
                                    {/* <FormControlLabel value="XSIP" control={
                                <Radio
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 18,
                                        },
                                    }}
                                />}
                                label="XSIP" /> */}
                                    <FormControlLabel value="Emandate" control={<Radio
                                        sx={{
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 18,
                                            },
                                        }} />} label="E-Mandate" />
                                </RadioGroup>
                                {radioValue === 'XSIP' ? <p style={{ color: '#5a7c82', userSelect: 'none' }}>This is a Physical Mandate which will require you to take a print, sign it and upload the scanned version.
                                    It takes 21 working days to get verified with your bank.</p>
                                    : <p style={{ color: '#5a7c82', userSelect: 'none' }}>This is a Digital Mandate which will require Netbanking Facility as you will be sent a link on which you have to make a payment of 1 Rupee from your bank account. It takes 2 working days to get this mandate verified. List of Allowed Banks is below.</p>}
                                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, flexWrap: 'wrap', gap: '1rem' }}>
                                    <div style={{ flex: '1 1 30%', minWidth: '13rem', userSelect: 'none' }}>
                                        <p>Mandate Amount <span style={{ color: 'red' }}>*</span></p>
                                        <input name='mandateAmount' type='text' placeholder='Enter amount' value={mandateValues.mandateAmount}
                                            onChange={(e) => {
                                                if (!isNaN(Number(e.target.value)) && Number(e.target.value) > 0)
                                                    setMandateValues({
                                                        ...mandateValues,
                                                        mandateAmount: e.target.value
                                                    })
                                                setError({ ...error, amount: '' })
                                            }}
                                            style={{
                                                width: "100%",
                                                maxWidth: '300px', // Set a maximum width
                                                borderRadius: '5px',
                                                border: "1px solid #C4C4C4", height: '2rem',
                                                boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
                                            }} />
                                        {error?.amount && <p style={{ fontSize: '13px', color: 'red' }}>{error.amount}</p>}
                                    </div>
                                    <div style={{ flex: '1 1 30%', minWidth: '13rem', userSelect: 'none' }}>
                                        <p>Bank Account <span style={{ color: 'red' }}>*</span></p>
                                        <FormControl sx={{ width: '100%', maxWidth: '300px' }}>
                                            {profileData?.bank_details?.length > 0 ? (
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    name='bankAccount'
                                                    value={mandateValues.bankAccount}
                                                    onChange={(e) => {
                                                        const selectedBankDetail = profileData?.bank_details.find((val: any) => e.target.value === val.ACNo);
                                                        console.log("selectedbankdetails", selectedBankDetail)

                                                        if (selectedBankDetail) {
                                                            setMandateValues({
                                                                ...mandateValues,
                                                                bankAccount: e.target.value,
                                                                bankName: selectedBankDetail.BankName,
                                                                ifscCode: selectedBankDetail.IFSCCode,
                                                                ac_type: selectedBankDetail.ACType
                                                            })
                                                        };
                                                        setError({ ...error, bank: '' })
                                                    }}
                                                    placeholder='Please Select'
                                                    sx={{
                                                        border: "none",
                                                        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                                        height: '2rem',
                                                        width: '100%', // Set to 100% for consistency
                                                        maxWidth: '300px', // Set a maximum width
                                                        borderRadius: '5px',
                                                        padding: '2px 3px',
                                                        fontSize: 15,
                                                    }}
                                                >
                                                    {profileData?.bank_details.map((item: any, index: number) => (
                                                        <MenuItem key={index} value={item.ACNo}> {item.ACNo}</MenuItem>
                                                    ))}
                                                </Select>
                                            ) : (
                                                <div style={{ height: '2rem', width: '100%', maxWidth: '300px', border: "1px solid #C4C4C4", borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>No bank details available</div>
                                            )}
                                        </FormControl>
                                        {error.bank && <p style={{ fontSize: '13px', color: 'red' }}>{error.bank}</p>}
                                    </div>
                                </Box>
                                {mandateValues.bankAccount &&
                                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
                                        <div style={{ flex: '1 1 30%', minWidth: '13rem' }}>
                                            <p>Bank Name <span style={{ color: 'red' }}>*</span></p>
                                            <input name='bankName' type='text' disabled value={mandateValues.bankName}
                                                style={{
                                                    width: "100%",
                                                    maxWidth: '300px', // Set a maximum width
                                                    borderRadius: '5px',
                                                    border: "1px solid #C4C4C4", height: '2rem',
                                                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                                    userSelect: 'none'
                                                }} />
                                        </div>
                                        <div style={{ flex: '1 1 30%', minWidth: '13rem' }}>
                                            <p>IFSC Code <span style={{ color: 'red' }}>*</span></p>
                                            <input name='ifscCode' type='text' disabled value={mandateValues.ifscCode}
                                                style={{
                                                    width: "100%",
                                                    maxWidth: '300px', // Set a maximum width
                                                    borderRadius: '5px',
                                                    border: "1px solid #C4C4C4", height: '2rem',
                                                    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                                    userSelect: 'none'
                                                }} />
                                        </div>
                                    </Box>
                                }
                                <Button
                                    onClick={handleSubmit}
                                    style={{
                                        height: '40px',
                                        color: 'white',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        cursor: 'pointer',
                                        borderRadius: '5px',
                                        background: '#337FC9',
                                        marginTop: '20px',
                                        width: '100%', // Set to 100% for consistency
                                        maxWidth: '300px', // Set a maximum width
                                        userSelect: 'none',
                                        ...responsiveStyles
                                    }}
                                    disabled={submitLoading}
                                >
                                    {submitLoading ? <CircularProgress size={24} color="inherit" /> : 'Submit New Mandate Request'}
                                </Button>
                            </>
                        )}
                    </Box>
                    {submitModalPopup ?
                        <Modal
                            open={submitModalPopup}
                            // onClose={() => setSubmitModalPopup(false)}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={{
                                position: 'absolute' as any,
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: 400,
                                bgcolor: 'background.paper',
                                borderRadius: '10px',
                                boxShadow: 24,
                                p: 4,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <>
                                    <Typography sx={{ textAlign: "center" }}>
                                        {
                                            registerMandateRes?.imandate_details.mandateId ?
                                                (<> <p>{registerMandateRes?.imandate_details.message}</p>
                                                    <p>Mandate ID: {registerMandateRes?.imandate_details.mandateId}</p>
                                                </>)
                                                :
                                                "Mandate could not be registered. Please try again later."
                                        }
                                    </Typography>
                                </>
                                <Button
                                    onClick={() => {
                                        setSubmitModalPopup(false);
                                        history.push('/investor-transactions', { investorId, investorName });
                                    }}
                                    sx={{ height: '30px', color: 'white', backgroundColor: '#337FC9', mt: 2.5, fontSize: '15px', fontWeight: 400, '&:hover': { backgroundColor: '#337FC9' }, }}
                                >
                                    Ok
                                </Button>
                            </Box>
                        </Modal> : <></>}

                </>

            </CommonLayout>

        </div>
    );
}